import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { coachCardUpdateApi } from "../../api/coachCardUpdateApi";

export const updateCoachCard = createAsyncThunk(
  "coachCardUpdate/updateCoachCard",
  async (checkoutSessionId, { rejectWithValue }) => {
    try {
      const response = await coachCardUpdateApi(checkoutSessionId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const coachCardUpdateSlice = createSlice({
  name: "coachCardUpdate",
  initialState: {
    loading: false,
    success: null,
    error: null,
  },
  reducers: {
    clearCoachCardUpdateState: (state) => {
      state.loading = false;
      state.success = null;
      state.error = null;
    },
    clearCoachCardUpdateError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCoachCard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCoachCard.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload;
        state.error = null;
      })
      .addCase(updateCoachCard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCoachCardUpdateState, clearCoachCardUpdateError } =
  coachCardUpdateSlice.actions;
export default coachCardUpdateSlice.reducer;
